<template>
  <div>
    <div class="hd-name">证件信息</div>
    <div style="margin:0 0 10px 10px;font-size:13px">
      {{ title }}
    </div>
    <div class="room-person">
      <van-cell-group>
        <van-cell class="custom-filed">
          <van-row>
            <van-col span="12">
              <van-field
                v-model="form.Name"
                required
                clearable
                label="姓名"
                placeholder="请输入姓名"
              />
            </van-col>
            <van-col span="12">
              <van-radio-group v-model="form.Sex" class="sex-area">
                <van-radio name="男">男</van-radio>
                <van-radio name="女">女</van-radio>
              </van-radio-group>
            </van-col>
          </van-row>
        </van-cell>
        <form-select
          label="证件类型"
          v-model="form.IdType"
          :columns="idTypeData"
          @change="handleIdType"
        ></form-select>
        <van-field
          label="证件号码"
          v-model="form.IdNumber"
          placeholder="请输入证件号码"
        />
      </van-cell-group>
      <van-row style="margin:10px 0">
        <van-col span="6" v-if="editStatus" offset="10">
          <van-button type="default" size="small" @click="cancelEdit" block
            >取消修改</van-button
          >
        </van-col>
        <van-col span="6" :offset="editStatus ? 1 : 17">
          <van-button type="primary" size="small" @click="addPerson" block>
            <van-icon name="plus" /> {{ btnText }}</van-button
          >
        </van-col>
        <!-- <van-col span="12">
            <van-button type="default" block>
              <van-icon name="video-o" /> 拍照增加</van-button
            >
          </van-col> -->
      </van-row>
      <table class="person-list">
        <tr>
          <th>姓名</th>
          <th>证件类型</th>
          <th>证件号码</th>
          <th>操作</th>
        </tr>
        <tr v-for="(item, index) in contactData" :key="index">
          <td>{{ item.Name }}</td>
          <td>{{ item.IdTypeName }}</td>
          <td>{{ item.IdNumber }}</td>
          <td style="padding-left:10px">
            <van-icon
              name="edit"
              color="#1989fa"
              size="20"
              v-if="!item.isNew"
              @click="editPerson(item, index)"
            />
            <van-icon
              name="close"
              color="#f00"
              size="20"
              style="margin-left:5px"
              @click="delPerson(index)"
            />
          </td>
        </tr>
      </table>

      <van-row class="btn-group">
        <van-col span="12">
          <van-button type="default" @click="onCancel" block>关闭</van-button>
        </van-col>
        <van-col span="12">
          <van-button type="info" @click="onSubmit" block>确认</van-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Row,
  Col,
  Icon,
  Field,
  Button,
  RadioGroup,
  Radio,
  Notify,
} from "vant";
import formSelect from "@/components/form-select";
import { mapState } from "vuex";
import { getSelectData } from "@/api/common.js";
import cloneDeep from "lodash/cloneDeep";
export default {
  name: "addContact",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Notify.name]: Notify,
    formSelect,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Function,
    },
    change: {
      type: Function,
    },
  },
  model: {
    props: "data",
    event: "updata",
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
    // contactData() {
    //   return this.data;
    // }
  },
  data() {
    return {
      form: {
        Name: "",
        Sex: "男",
        IdType: "",
        IdTypeName: "",
        IdNumber: "",
        isNew: true,
      },
      idTypeData: [],
      title: "新增",
      editStatus: false,
      editIndex: 0,
      btnText: "手动增加",
      contactData: [],
    };
  },
  created() {
    this.getRoomSelectData();
    this.contactData = cloneDeep(this.data);
  },
  methods: {
    show() {
      this.contactData = cloneDeep(this.data);
    },
    /**获取证件类型 */
    getRoomSelectData() {
      //获取价构列表
      getSelectData({
        Types: "idType",
      }).then(res => {
        this.idTypeData = res.Data.idType;
        // this.form.IdType = this.idTypeData[0].Id;
      });
    },
    handleIdType(data) {
      this.form.IdTypeName = data.Text;
    },
    delPerson(index) {
      this.contactData.splice(index, 1);
    },
    editPerson(item, index) {
      this.editIndex = index;
      this.title = "修改";
      this.editStatus = true;
      this.btnText = "确认修改";
      // const defaultIdTypeId =
      //   this.idTypeData && this.idTypeData[0] && this.idTypeData[0].Id;
      // const defaultIdTypeName =
      //   this.idTypeData && this.idTypeData[0] && this.idTypeData[0].Text;
      this.form = {
        Id: item.Id,
        Name: item.Name,
        Sex: item.Sex ? item.Sex : "男",
        IdType: item.IdType && item.IdType != "0" ? item.IdType : "",
        IdTypeName: item.IdTypeName ? item.IdTypeName : "",
        IdNumber: item.IdNumber,
      };
    },
    cancelEdit() {
      this.resetForm();
    },
    addPerson() {
      if (!this.form.Name) {
        Notify("请填写姓名！");
        return false;
      }
      if (!this.form.IdType && this.form.IdNumber) {
        Notify("请选择证件类型！");
        return false;
      }
      if (!this.form.IdNumber && this.form.IdType) {
        Notify("请填写证件号码！");
        return false;
      }
      if (this.form.IdNumber && this.form.IdType) {
        var idcardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (
          !idcardReg.test(this.form.IdNumber) &&
          this.form.IdTypeName &&
          this.form.IdTypeName.includes("身份证")
        ) {
          Notify("身份证格式不对！");
          return false;
        }
      }
      if (this.editStatus) {
        this.form.isNew = false;
        this.contactData[this.editIndex] = cloneDeep(this.form);
      } else {
        this.form.isNew = true;
        this.contactData.push(this.form);
      }
      this.resetForm();
    },
    onSubmit() {
      this.contactData = this.contactData.map(v => {
        if (v.IdType == "") {
          v.IdType = 0;
        }
        return v;
      });
      this.$emit("updata", this.contactData);
      this.$emit("update", this.contactData);
      this.$parent.close();
      this.resetForm();
    },
    onCancel() {
      this.resetForm();
      this.$parent.close();
    },
    resetForm() {
      this.form = {
        Name: "",
        Sex: "男",
        IdType: 0,
        IdTypeName: "",
        IdNumber: "",
      };
      this.title = "新增";
      this.editStatus = false;
      this.btnText = "手动增加";
    },
  },
};
</script>
<style lang="less">
.hd-name {
  text-align: center;
  font-size: 0.42667rem;
  height: 50px;
  line-height: 50px;
}
.room-person {
  /deep/.van-radio-group {
    // display: inline-flex;
    line-height: 44px;
    height: 44px;
    .van-radio {
      margin-right: 20px;
      // flex: 1;
    }
  }
}
.person-list {
  width: 100%;
  margin: 0 auto;
  // border-top: 3px solid #f5f5f9;
  padding-top: 20px;
  th,
  td {
    font-weight: normal;
    font-size: 14px;
    padding: 5px 10px;
    color: #999;
    text-align: left;
  }
  td {
    border-bottom: 1px dashed #ebebeb;
  }
  th {
    background: #f5f5f9;
    color: #565656;
  }
}
.btn-group {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.custom-filed {
  padding: 0;
  /deep/.van-field__label {
    width: 1.9rem;
  }
}
.sex-area {
  display: flex;
  height: 43px;
  justify-content: space-around;
}
</style>
